
import DesktopLayout from '@/layout/desktop-layout'

let routes = [
  {
    path: '/pc',
    component: DesktopLayout,
    children: [
      {
        path: '',
        name: 'pc_home',
        redirect: {
          name: 'exams'
        },
        meta: {
          is_admin: true,
          title: '班级管理主页',
          breadcrumb: '班级管理主页'
        }
      },
      {
        path: 'examination',
        component: { template: "<router-view />"},
        meta: {
          is_admin: true,
          title: '在线考试',
          breadcrumb: '在线考试'
        },
        children: [
          {
            path: '',
            name: 'examination_papers',
            component: () => import('@/views/pc/examination_papers'),
            meta: {
              is_admin: true,
              title: '试卷管理',
            },
          },
          {
            path: 'create_papers',
            name: 'create_papers',
            component: () => import('@/views/pc/create_papers'),
            meta: {
              is_admin: true,
              title: '创建试卷',
            }
          },
          {
            path: 'edit_paper/:id',
            name: 'edit_paper',
            component: () => import('@/views/pc/create_papers'),
            meta: {
              is_admin: true,
              title: '修改试卷',
            }
          },
          {
            path: 'record',
            name: 'examination_record',
            component: () => import('@/views/pc/examination_record'),
            meta: {
              is_admin: true,
              title: '考试记录'
            }    
          },
          {
            path: 'preview/:id',
            name: 'preview_paper',
            component: () => import('@/views/pc/paper_preview'),
            meta: {
              is_admin: true,
              title: '试卷预览',
            }
          },    
        ]
      },
      {
        path: 'post',
        component: { template: "<router-view />"},
        meta: {
          is_admin: true,
          title: '班级发布',
          breadcrumb: '班级发布'
        },
        children: [
          {
            path: '',
            name: 'create_post',
            component: () => import('@/views/pc/create_post'),
            meta: {
              is_admin: true,
              title: '班级发布',
            }    
          },
          {
            path: ':type/:id/success',
            name: 'create_post_success',
            component: () => import('@/views/pc/create_post_success'),
            meta: {
              is_admin: true,
              title: '发布成功'
            }    
          },
        ]
      },
      {
        path: 'exams',
        component: { template: "<router-view />"},
        meta: {
          is_admin: true,
          title: '成绩管理',
          breadcrumb: '成绩管理'
        },
        children: [
          {
            path: '',
            name: 'exams',
            component: () => import('@/views/pc/exams'),
            meta: {
              is_admin: true,
              title: '成绩管理'
            }    
          },
          {
            path: 'publish_scores',
            name: 'publish_scores',
            component: () => import('@/views/pc/publish_scores'),
            meta: {
              is_admin: true,
              title: '发布成绩',
              breadcrumb: '发布成绩'
            }
          },
          {
            path: 'create_publish_scores',
            name: 'create_publish_scores',
            component: () => import('@/views/pc/publish_scores'),
            meta: {
              is_admin: false,
              title: '发布成绩',
              breadcrumb: '发布成绩'
            }
          },
          {
            path: ':exam_id/publish_success',
            name: 'publish_success',
            component: () => import('@/views/pc/publish_success'),
            meta: {
              is_admin: true,
              title: '发布成绩',
              breadcrumb: '发布成绩'
            }
          },
          {
            path: ':exam_id/scores',
            name: 'scores',
            component: () => import('@/views/pc/scores'),
            meta: {
              is_admin: true,
              title: '查看成绩',
              breadcrumb: '查看成绩'
            }
          }
        ],
      }
    ]
  },
  {
    path: '/pc/login',
    name: 'pc_login',
    component: () => import('@/views/pc/login'),
    meta: {
      no_auth: true,
      title: '账户登录'
    }
  },
  {
    path: '/pc/comment',
    name: 'comment',
    component: () => import('@/views/pc/comment'),
    meta: {
      no_auth: true,
      title: '评语生成'
    }
  },
  {
    path: '/pc/comment/:class_id',
    name: 'class_comment',
    component: () => import('@/views/pc/comment'),
    meta: {
      title: '评语生成'
    }
  },
  {
    path: '/pc/post_certificate',
    name: 'pc_post_certificate',
    component: () => import('@/views/pc/pc_post_certificate'),
    meta: {
      no_auth: true,
      title: '在线奖状'
    }
  }
]

export default routes;


// WEBPACK FOOTER //
// ./src/router/desktop_routes.js